<p-toast></p-toast>

<div class="gph-tools">
    <div class="header">
        <div>
            <h2>GPH Tools</h2>
            <span>Manage the manual GPH roster by shift and date range. Times are Manila time.</span>
        </div>
        <button pButton label="Assign driver" icon="pi pi-plus" [disabled]="!programs.length" (click)="openAssign()"></button>
    </div>

    <div class="toolbar">
        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Driver ID, name, or Xpress User ID</mat-label>
            <input matInput [(ngModel)]="search" />
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
        <p-dropdown styleClass="shift-filter" [options]="programs" [(ngModel)]="selectedIncentiveId" optionLabel="Name" optionValue="IncentiveId"
                    [showClear]="true" placeholder="All GPH shifts" appendTo="body"></p-dropdown>
    </div>

    <p-table [value]="filteredAssignments" [loading]="loading" styleClass="gph-tools-table">
        <ng-template pTemplate="header"><tr>
            <th>Shift</th><th>Driver</th><th>Xpress user</th><th>Effective window (UTC)</th><th>Effective window (PHT)</th><th>Source</th><th>Action</th>
        </tr></ng-template>
        <ng-template pTemplate="body" let-row><tr>
            <td><strong>{{row.IncentiveName}}</strong><div class="secondary">#{{row.IncentiveId}} · {{shiftWindow(row.IncentiveId)}}</div></td>
            <td><strong>{{row.RiderId}}</strong><div class="secondary">{{row.RiderName}}</div></td>
            <td>{{row.XpressUserId}}</td>
            <td>{{row.EffectiveFromUtc | date:'medium':'+0000'}}<div class="secondary">until {{row.EffectiveToUtc ? (row.EffectiveToUtc | date:'medium':'+0000') : 'manually closed'}}</div></td>
            <td>{{row.EffectiveFromUtc | date:'medium':'+0800'}}<div class="secondary">until {{row.EffectiveToUtc ? (row.EffectiveToUtc | date:'medium':'+0800') : 'manually closed'}}</div></td>
            <td>{{row.Source || '—'}}</td>
            <td><button pButton class="p-button-sm p-button-danger p-button-outlined" label="Remove" (click)="openRemove(row)"></button></td>
        </tr></ng-template>
        <ng-template pTemplate="emptymessage"><tr><td colspan="7">No active GPH assignments found.</td></tr></ng-template>
    </p-table>
</div>

<p-dialog header="Assign GPH driver" [(visible)]="assignDialog" [modal]="true" styleClass="gph-tools-dialog" [style]="{width:'560px'}" [breakpoints]="{'640px':'95vw'}">
    <div class="form-grid">
        <label>GPH shift</label>
        <p-dropdown [options]="programs" [(ngModel)]="selectedProgram" optionLabel="Name" placeholder="Select GPH shift"
                    appendTo="body" [baseZIndex]="10030" (onChange)="onAssignProgramChange()">
            <ng-template pTemplate="item" let-program><div>{{program.Name}}</div><small>{{shiftLabel(program)}} · max {{program.MaxParticipants ?? 'unlimited'}}</small></ng-template>
        </p-dropdown>
        <div class="secondary" *ngIf="selectedProgram">{{shiftLabel(selectedProgram)}} · Zone {{selectedProgram.ZoneId}}</div>
        <label>Roster starts (Manila)</label>
        <input pInputText type="date" [(ngModel)]="rosterFromDate" />
        <label>Roster ends (Manila)</label>
        <input pInputText type="date" [(ngModel)]="rosterToDate" [min]="rosterFromDate" />
        <label>Driver ID</label>
        <p-inputNumber [(ngModel)]="riderId" [useGrouping]="false" [min]="1" placeholder="Rider ID"></p-inputNumber>
        <label>Reason (optional)</label>
        <input pInputText [(ngModel)]="reason" maxlength="500" placeholder="e.g. Approved operations roster" />
        <div class="notice">Only active Sedan and SUV drivers can be assigned. One roster entry covers every occurrence of the selected shift in this date range.</div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" class="p-button-text" [disabled]="actionBusy" (click)="assignDialog=false"></button>
        <button pButton label="Assign" [loading]="actionBusy" [disabled]="!selectedProgram || !riderId || !rosterFromDate || !rosterToDate" (click)="assign()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Remove GPH driver" [(visible)]="removeDialog" [modal]="true" styleClass="gph-tools-dialog" [style]="{width:'520px'}" [breakpoints]="{'640px':'95vw'}">
    <div class="form-grid" *ngIf="selectedAssignment">
        <div class="summary"><strong>{{selectedAssignment.RiderId}} · {{selectedAssignment.RiderName}}</strong><span>{{selectedAssignment.IncentiveName}}</span></div>
        <label>Reason (optional)</label>
        <input pInputText [(ngModel)]="reason" maxlength="500" placeholder="e.g. Removed from operations roster" />
        <div class="notice">For a future shift this leaves an empty interval. For a live shift, coverage ends now and the audit history records the removal.</div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" class="p-button-text" [disabled]="actionBusy" (click)="removeDialog=false"></button>
        <button pButton label="Remove" class="p-button-danger" [loading]="actionBusy" (click)="remove()"></button>
    </ng-template>
</p-dialog>
